import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { TradeType } from "@/lib/interfaces and Enums/ENUMTradeType";
import { IHeaderParams } from "ag-grid-community";
import { useState } from "react";

/**
 * ExpandCollapseAllHeader
 *
 * Custom header component for the expand column in master-detail grids.
 * Provides expand all / collapse all functionality for Order fills.
 */
const ExpandCollapseAllHeader = (props: IHeaderParams) => {
  const [allExpanded, setAllExpanded] = useState(true); // Default expanded for Orders

  const colDef = props?.column?.getColDef();
  const isOrder =
    colDef?.cellRendererParams?.fullTradeData?.type == TradeType.Order;
  if (!isOrder) {
    return;
  }
  const status = colDef?.cellRendererParams?.fullTradeData?.status;

  if (
    (status == ExecutionStrategyStatus.Received && isOrder) ||
    (status == ExecutionStrategyStatus.Sent && isOrder)
  ) {
    return; // Don't allow expanding on orders.
  }

  const handleToggleAll = () => {
    if (!props.api) return;

    const collapsedBlocks = props.context?.collapsedFillBlocks;
    const blockNodesToRedraw: any[] = [];

    if (allExpanded) {
      // Collapse all: add all block IDs to collapsed set
      props.api.forEachNode((node) => {
        if (node.data?.rowType === "block" && collapsedBlocks) {
          collapsedBlocks.add(node.data.blockId);
          blockNodesToRedraw.push(node);
        }
      });
    } else {
      // Expand all: clear the collapsed set
      props.api.forEachNode((node) => {
        if (node.data?.rowType === "block") {
          blockNodesToRedraw.push(node);
        }
      });
      collapsedBlocks?.clear();
    }

    setAllExpanded(!allExpanded);
    props.api.onFilterChanged();
    // Force redraw of block rows to update expand cell icons
    if (blockNodesToRedraw.length > 0) {
      props.api.redrawRows({ rowNodes: blockNodesToRedraw });
    }
  };

  return (
    <div
      data-testid="expandCollapseAllHeaderContainer"
      id="expandCollapseAllHeaderContainer"
      className="flex h-full w-full cursor-pointer items-center justify-center"
      onClick={handleToggleAll}
      title={allExpanded ? "Collapse all fills" : "Expand all fills"}
    >
      <span
        className={`ag-icon pl-1 ${allExpanded ? "ag-icon-tree-open" : "ag-icon-tree-closed"}`}
      />
    </div>
  );
};

export default ExpandCollapseAllHeader;
